import { useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useEnv } from '../config/env';
import type { Side } from '../hl/outcomes';
import { parseOutcomeId } from '../market/outcomeId';
import MarketView, { NotFound } from '../market/MarketView';

function parseSide(v: string | null): Side {
  return v === '1' ? 1 : 0;
}

export default function MarketPage() {
  const { outcomeId: raw = '' } = useParams();
  const { env } = useEnv();
  const [params, setParams] = useSearchParams();
  const id = parseOutcomeId(raw);
  const side = parseSide(params.get('side'));
  const selectSide = useCallback(
    (s: Side) => {
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev); // keeps ?ghost= and anything else
          next.set('side', String(s));
          return next;
        },
        { replace: true },
      );
    },
    [setParams],
  );

  if (id === null) return <NotFound raw={raw} envName={env.name} />;
  return <MarketView id={id} raw={raw} side={side} onSide={selectSide} />;
}
